import ToggleButton from "../../02-molecules/Buttons/buttonToggle";

export default class CloseButton extends ToggleButton {
  /**
   * creates an instance of ToggleButton
   * @extends ToggleButton
   */

  constructor() {
    super(".egat-newsalert [data-js-button='toggle-button']"); // call ToggleButton-Instance

    this.hiddenClass = "js-hidden";
    this.closeButtonSelector = "[data-js-button='toggle-button']";

    this.alertArray = Array.from(document.querySelectorAll(".egat-newsalert"));

    this.defaultEvent();
  }

  defaultEvent() {
    if (this.alertArray) {
      this.alertArray.forEach(alert => {
        const closeButton = alert.querySelector(this.closeButtonSelector);
        if (closeButton) {
          closeButton.addEventListener("click", () => {
            const currentAlert = closeButton.closest(".egat-newsalert");
            currentAlert.classList.add(this.hiddenClass);
          });
        }
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CloseButton();
});
